// export const BACKEND_URL = "http://localhost:8000/";
export const BACKEND_URL = "https://dev.geothara.com/";
export const Frontend_URL = "https://geothara.com/";
// export const Frontend_URL = "http://localhost:3000/";
